export default "__VITE_ASSET__vTU4mmH6__"